/*!
	Copyright (c) 2011-2015, Pavel Shramov, Bruno Bergot - MIT licence
*/


import * as L from 'leaflet';
import * as JSZip from 'jszip';

L.KML = L.FeatureGroup.extend({
//export var KML = L.FeatureGroup.extend({

	initialize: function (kml, kmlOptions) {
		this._kml = kml;
		this._layers = {};
		this._kmlOptions = kmlOptions;

		if (kml) {
			this.addKML(kml, kmlOptions);
		}
	},

	addKML: function (xml, kmlOptions) {
		var layers = L.KML.parseKML(xml, kmlOptions);
		if (!layers || !layers.length) {
			console.warn('KML: No layers parsed from XML');
			return;
		}
		for (var i = 0; i < layers.length; i++) {
			this.fire('addlayer', {
				layer: layers[i]
			});
			this.addLayer(layers[i]);
		}
		this.latLngs = L.KML.getLatLngs(xml);
		this.fire('loaded');
	},

	addKMZ: async function(kmzSource, kmlOptions) {
		try {
			console.log('KMZ: Loading started');
			let kmzData;

			// Handle URL
			if (typeof kmzSource === 'string') {
				const response = await fetch(kmzSource);
				if (!response.ok) {
					throw new Error('Failed to fetch KMZ file: ' + response.statusText);
				}
				kmzData = await response.arrayBuffer();
			} 
			// Handle File object or Blob
			else if (kmzSource instanceof File || kmzSource instanceof Blob) {
				kmzData = await kmzSource.arrayBuffer();
			}
			else {
				throw new Error('KMZ source must be a URL string or File/Blob object');
			}

			// Unzip the KMZ
			const zip = await JSZip.loadAsync(kmzData);
			
			// Find the main KML file (usually doc.kml or the first .kml file)
			let kmlFile = zip.file('doc.kml');
			if (!kmlFile) {
				// Find first .kml file
				const kmlFiles = Object.keys(zip.files).filter(name => name.endsWith('.kml') && !name.startsWith('__MACOSX'));
				if (kmlFiles.length === 0) {
					throw new Error('No KML file found in KMZ archive');
				}
				console.log('KMZ: Found KML files:', kmlFiles);
				kmlFile = zip.file(kmlFiles[0]);
			}

			// Extract and parse the KML
			const kmlText = await kmlFile.async('string');
			const parser = new DOMParser();
			const kmlDoc = parser.parseFromString(kmlText, 'text/xml');

			// Check for parsing errors
			const parserError = kmlDoc.getElementsByTagName('parsererror');
			if (parserError.length > 0) {
				throw new Error('Failed to parse KML from KMZ: ' + parserError[0].textContent);
			}

			console.log('KMZ: Successfully extracted and parsing KML');
			this.addKML(kmlDoc, kmlOptions);
			
		} catch (error) {
			console.error('KMZ: Error loading KMZ file:', error);
			this.fire('error', { error: error });
		}
	},

	latLngs: []
});

L.Util.extend(L.KML, {
//KML.extend(KML, {

	parseKML: function (xml, kmlOptions) {
        var style = this.parseStyles(xml, kmlOptions);
		this.parseStyleMap(xml, style);
		var el = xml.getElementsByTagName('Folder');
		var layers = [], l;
		for (var i = 0; i < el.length; i++) {
			if (!this._check_folder(el[i])) { continue; }
			l = this.parseFolder(el[i], style);
			if (l) { layers.push(l); }
		}
		el = xml.getElementsByTagName('Placemark');
		for (var j = 0; j < el.length; j++) {
			if (!this._check_folder(el[j])) { continue; }
			l = this.parsePlacemark(el[j], xml, style);
			if (l) { layers.push(l); }
		}
		el = xml.getElementsByTagName('GroundOverlay');
		for (var k = 0; k < el.length; k++) {
			l = this.parseGroundOverlay(el[k]);
			if (l) { layers.push(l); }
		}
		return layers;
	},

	// Return false if e's first parent Folder is not [folder]
	// - returns true if no parent Folders
	_check_folder: function (e, folder) {
		e = e.parentNode;
		while (e && e.tagName !== 'Folder')
		{
			e = e.parentNode;
		}
		return !e || e === folder;
	},

	parseStyles: function (xml, kmlOptions) {
		var styles = {};

		// Handle gx:CascadingStyle (Google Earth's newer KML format).
		// The id lives on the wrapper as kml:id; the inner <Style> has no id.
		var cascading = xml.getElementsByTagName('gx:CascadingStyle');
		for (var c = 0; c < cascading.length; c++) {
			var cs = cascading[c];
			var csId = cs.getAttribute('kml:id') || cs.getAttribute('id');
			var csStyleEl = cs.getElementsByTagName('Style')[0];
			if (csId && csStyleEl) {
				var csStyle = this.parseStyle(csStyleEl, kmlOptions);
				if (csStyle) {
					csStyle.id = csId;
					styles['#' + csId] = csStyle;
				}
			}
		}

		// Handle regular <Style id="..."> elements,
		// skipping any that are already handled as children of gx:CascadingStyle.
		var sl = xml.getElementsByTagName('Style');
		for (var i = 0, len = sl.length; i < len; i++) {
			if (sl[i].parentNode && (sl[i].parentNode as any).localName === 'CascadingStyle') { continue; }
			var style = this.parseStyle(sl[i], kmlOptions);
			if (style) {
				var styleName = '#' + style.id;
				styles[styleName] = style;
			}
		}
		return styles;
	},

	parseStyle: function (xml, kmlOptions) {
		var style = {} as any, poptions = {} as any, ioptions = {} as any, el, id;

		var attributes = {color: true, width: true, Icon: true, href: true, hotSpot: true};

		function _parse (xml) {
            var options = {} as any;
			for (var i = 0; i < xml.childNodes.length; i++) {
				var e = xml.childNodes[i];
				var key = e.tagName;
				if (!attributes[key]) { continue; }
				if (key === 'hotSpot')
				{
					for (var j = 0; j < e.attributes.length; j++) {
						options[e.attributes[j].name] = e.attributes[j].nodeValue;
					}
				} else {
					var value = e.textContent ? e.textContent.trim() : null;
					if(!value) {
						continue;
					}
					if (key === 'color') {
						options.opacity = parseInt(value.substring(0, 2), 16) / 255.0;
						options.color = '#' + value.substring(6, 8) + value.substring(4, 6) + value.substring(2, 4);
					} else if (key === 'width') {
						options.weight = parseInt(value);
					} else if (key === 'Icon') {
                        ioptions = _parse(e);
						if (ioptions.href) { options.href = ioptions.href; }
					} else if (key === 'href') {
						// Strip whitespace from data URIs (base64 strings are often line-wrapped in KML)
						options.href = value && value.startsWith('data:') ? value.replace(/\s+/g, '') : value;
					}
				}
			}
			return options;
		}

		el = xml.getElementsByTagName('LineStyle');
		if (el && el[0]) { style = _parse(el[0]); }
		el = xml.getElementsByTagName('PolyStyle');
		if (el && el[0]) { poptions = _parse(el[0]); }
		if (poptions.color) { style.fillColor = poptions.color; }
		if (poptions.opacity) { style.fillOpacity = poptions.opacity; }
		el = xml.getElementsByTagName('IconStyle');
		if (el && el[0]) { 
            ioptions = _parse(el[0]);
        }
		if (ioptions.href) {
			var iconOptions = {
				iconUrl: ioptions.href,
				shadowUrl: null,
				anchorRef: {x: ioptions.x, y: ioptions.y},
				anchorType:	{x: ioptions.xunits, y: ioptions.yunits}
			};

			if (typeof kmlOptions === "object" && typeof kmlOptions.iconOptions === "object") {
				L.Util.extend(iconOptions, kmlOptions.iconOptions);
			}

			style.icon = new L.KMLIcon(iconOptions);
		}

		id = xml.getAttribute('id');
		if (id && style) {
			style.id = id;
		}

		return style;
	},

	parseStyleMap: function (xml, existingStyles) {
		var sl = xml.getElementsByTagName('StyleMap');

		for (var i = 0; i < sl.length; i++) {
			var e = sl[i];
			var smId = e.getAttribute('id');
			var pairs = e.getElementsByTagName('Pair');
			for (var p = 0; p < pairs.length; p++) {
				var keyEl = pairs[p].getElementsByTagName('key')[0];
				var styleUrlEl = pairs[p].getElementsByTagName('styleUrl')[0];
				if (!keyEl || !styleUrlEl) { continue; }
				var smKey = keyEl.textContent.trim();
				var smStyleUrl = styleUrlEl.textContent.trim();
				if (smKey === 'normal') {
					existingStyles['#' + smId] = existingStyles[smStyleUrl];
					break;
				}
			}
		}

		return;
	},

	parseFolder: function (xml, style) {
		var el, layers = [], l;
		el = xml.getElementsByTagName('Folder');
		for (var i = 0; i < el.length; i++) {
			if (!this._check_folder(el[i], xml)) { continue; }
			l = this.parseFolder(el[i], style);
			if (l) { layers.push(l); }
		}
		el = xml.getElementsByTagName('Placemark');
		for (var j = 0; j < el.length; j++) {
			if (!this._check_folder(el[j], xml)) { continue; }
			l = this.parsePlacemark(el[j], xml, style);
			if (l) { layers.push(l); }
		}
		el = xml.getElementsByTagName('GroundOverlay');
		for (var k = 0; k < el.length; k++) {
			if (!this._check_folder(el[k], xml)) { continue; }
			l = this.parseGroundOverlay(el[k]);
			if (l) { layers.push(l); }
		}
		if (!layers.length) { return; }
		if (layers.length === 1) {
			l = layers[0];
		} else {
			l = new L.FeatureGroup(layers);
		}
		el = xml.getElementsByTagName('name');
		if (el.length && el[0].childNodes.length) {
			l.options.name = el[0].childNodes[0].nodeValue;
		}
		return l;
	},

	parsePlacemark: function (place, xml, style, options) {
		var h, i, j, k, el, il, opts = options || {};

		el = place.getElementsByTagName('styleUrl');
		for (i = 0; i < el.length; i++) {
			var url = el[i].childNodes[0].nodeValue;
			for (var a in style[url]) {
				opts[a] = style[url][a];
			}
		}

		il = place.getElementsByTagName('Style')[0];
		if (il) {
			var inlineStyle = this.parseStyle(place);
			if (inlineStyle) {
				for (k in inlineStyle) {
					opts[k] = inlineStyle[k];
				}
			}
		}

		var multi = ['MultiGeometry', 'MultiTrack', 'gx:MultiTrack'];
		for (h in multi) {
			el = place.getElementsByTagName(multi[h]);
			for (i = 0; i < el.length; i++) {
				var layer = this.parsePlacemark(el[i], xml, style, opts);
				if (layer === undefined)
					continue;
				this.addPlacePopup(place, layer);
				return layer;
			}
		}

		var layers = [];

		var parse = ['LineString', 'Polygon', 'Point', 'Track', 'gx:Track'];
		for (j in parse) {
			var tag = parse[j];
			el = place.getElementsByTagName(tag);
			for (i = 0; i < el.length; i++) {
				var l = this['parse' + tag.replace(/gx:/, '')](el[i], xml, opts);
				if (l) { layers.push(l); }
			}
		}

		if (!layers.length) {
			return;
		}
		var layer = layers[0];
		if (layers.length > 1) {
			layer = new L.FeatureGroup(layers);
		}

		this.addPlacePopup(place, layer);
		return layer;
	},

    addPlacePopup: function(place, layer) {
        var el, i, j, name, descr = '';
        el = place.getElementsByTagName('name');
        if (el.length && el[0].childNodes.length) {
        name = el[0].childNodes[0].nodeValue;
        }
        el = place.getElementsByTagName('description');
        for (i = 0; i < el.length; i++) {
        for (j = 0; j < el[i].childNodes.length; j++) {
            descr = descr + el[i].childNodes[j].nodeValue;
        }
        }

        if (name) {
        layer.bindPopup('<h2>' + name + '</h2>' + descr, { className: 'kml-popup'});
        }
    },

	parseCoords: function (xml) {
		var el = xml.getElementsByTagName('coordinates');
		if (!el || !el.length || !el[0]) {
			console.warn('KML: No coordinates element found');
			return [];
		}
		return this._read_coords(el[0]);
	},

	parseLineString: function (line, xml, options) {
		var coords = this.parseCoords(line);
		if (!coords.length) { return; }
		return new L.Polyline(coords, options);
	},

	parseTrack: function (line, xml, options) {
		var el = xml.getElementsByTagName('gx:coord');
		if (el.length === 0) { el = xml.getElementsByTagName('coord'); }
		var coords = [];
		for (var j = 0; j < el.length; j++) {
			coords = coords.concat(this._read_gxcoords(el[j]));
		}
		if (!coords.length) { return; }
		return new L.Polyline(coords, options);
	},

	parsePoint: function (line, xml, options) {
		var el = line.getElementsByTagName('coordinates');
		if (!el.length) {
			console.warn('KML: No coordinates found for Point');
			return;
		}
		try {
			if (!el[0].childNodes || !el[0].childNodes[0]) {
				console.warn('KML: Empty coordinates element for Point');
				return;
			}
			var coordText = el[0].childNodes[0].nodeValue;
			var ll = coordText.trim().split(',');
			if (ll.length < 2) {
				console.warn('KML: Invalid point coordinates:', coordText);
				return;
			}
			var lat = parseFloat(ll[1]);
			var lng = parseFloat(ll[0]);
			if (isNaN(lat) || isNaN(lng)) {
				console.warn('KML: Invalid lat/lng for point:', ll);
				return;
			}
			return new L.KMLMarker(new L.LatLng(lat, lng), options);
		} catch (e) {
			console.error('KML: Error parsing point:', e);
			return;
		}
	},

	parsePolygon: function (line, xml, options) {
		var el, polys = [], inner = [], i, coords;
		el = line.getElementsByTagName('outerBoundaryIs');
		for (i = 0; i < el.length; i++) {
			coords = this.parseCoords(el[i]);
			if (coords && coords.length > 0) {
				polys.push(coords);
			}
		}
		el = line.getElementsByTagName('innerBoundaryIs');
		for (i = 0; i < el.length; i++) {
			coords = this.parseCoords(el[i]);
			if (coords && coords.length > 0) {
				inner.push(coords);
			}
		}
		if (!polys.length) {
			console.warn('KML: No valid polygons found');
			return;
		}
		
		// Set default fill options if not specified
		if (!options.fill && !options.fillColor) {
			options.fill = true;
			options.fillOpacity = options.fillOpacity || 0.2;
		}
		
		if (options.fillColor) {
			options.fill = true;
		}
		if (polys.length === 1) {
			return new L.Polygon(polys.concat(inner), options);
		}
		return new L.MultiPolygon(polys, options);
	},

	getLatLngs: function (xml) {
		var el = xml.getElementsByTagName('coordinates');
		var coords = [];
		for (var j = 0; j < el.length; j++) {
			// text might span many childNodes
			coords = coords.concat(this._read_coords(el[j]));
		}
		return coords;
	},

	_read_coords: function (el) {
		var text : any = '', coords = [], i;
		try {
			for (i = 0; i < el.childNodes.length; i++) {
				text = text + el.childNodes[i].nodeValue;
			}
			text = text.split(/[\s\n]+/);
			for (i = 0; i < text.length; i++) {
				var ll = text[i].split(',');
				if (ll.length < 2) {
					if (text[i].trim()) {
						console.warn('KML: Skipping invalid coordinate:', text[i]);
					}
					continue;
				}
				var lat = parseFloat(ll[1]);
				var lng = parseFloat(ll[0]);
				if (isNaN(lat) || isNaN(lng)) {
					console.warn('KML: Invalid lat/lng values:', ll);
					continue;
				}
				coords.push(new L.LatLng(lat, lng));
			}
		} catch (e) {
			console.error('KML: Error parsing coordinates:', e);
		}
		return coords;
	},

	_read_gxcoords: function (el) {
		var text = '', coords = [];
		text = el.firstChild.nodeValue.split(' ');
		coords.push(new L.LatLng(text[1], text[0]));
		return coords;
	},

	parseGroundOverlay: function (xml) {
		var latlonbox = xml.getElementsByTagName('LatLonBox')[0];
		var bounds = new L.LatLngBounds(
			[
				latlonbox.getElementsByTagName('south')[0].childNodes[0].nodeValue,
				latlonbox.getElementsByTagName('west')[0].childNodes[0].nodeValue
			],
			[
				latlonbox.getElementsByTagName('north')[0].childNodes[0].nodeValue,
				latlonbox.getElementsByTagName('east')[0].childNodes[0].nodeValue
			]
		);
		var attributes = {Icon: true, href: true, color: true};
		function _parse (xml) {
			var options = {} as any, ioptions = {} as any;
			for (var i = 0; i < xml.childNodes.length; i++) {
				var e = xml.childNodes[i];
				var key = e.tagName;
				if (!attributes[key]) { continue; }
				var value = e.textContent ? e.textContent.trim() : null;
				if (key === 'Icon') {
					ioptions = _parse(e);
					if (ioptions.href) { options.href = ioptions.href; }
				} else if (key === 'href') {
					// Strip whitespace from data URIs (base64 strings are often line-wrapped in KML)
					options.href = value && value.startsWith('data:') ? value.replace(/\s+/g, '') : value;
				} else if (key === 'color') {
					options.opacity = parseInt(value.substring(0, 2), 16) / 255.0;
					options.color = '#' + value.substring(6, 8) + value.substring(4, 6) + value.substring(2, 4);
				}
			}
			return options;
		}
		var options = {} as any;
		options = _parse(xml);
		if (latlonbox.getElementsByTagName('rotation')[0] !== undefined) {
			var rotation = latlonbox.getElementsByTagName('rotation')[0].childNodes[0].nodeValue;
			options.rotation = parseFloat(rotation);
		}
		if (!options.href || options.href === 'undefined' || options.href === 'null') {
			console.warn('KML: GroundOverlay has no valid image href, skipping. href:', options.href);
			return null;
		}
		return new L.RotatedImageOverlay(options.href, bounds, {opacity: options.opacity, angle: options.rotation});
	}

});

L.KMLIcon = L.Icon.extend({
	options: {
		iconSize: [32, 32],
		iconAnchor: [16, 16],
	},
	_setIconStyles: function (img, name) {
		L.Icon.prototype._setIconStyles.apply(this, [img, name]);
	},
	_createImg: function (src, el) {
		el = el || document.createElement('img');
		if (!src || src === 'undefined' || src === 'null') {
			console.warn('KML: icon has no valid src:', src);
			return el;
		}
		el.onload = this.applyCustomStyles.bind(this, el);
		el.onerror = function() {
			console.error('KML: Failed to load icon:', src);
		};
		el.src = src;
		return el;
	},
	applyCustomStyles: function(img) {
		var options = this.options;
		var width = options.iconSize[0];
		var height = options.iconSize[1];

		this.options.popupAnchor = [0,(-0.83*height)];
		if (options.anchorType.x === 'fraction')
			img.style.marginLeft = (-options.anchorRef.x * width) + 'px';
		if (options.anchorType.y === 'fraction')
			img.style.marginTop  = ((-(1 - options.anchorRef.y) * height) + 1) + 'px';
		if (options.anchorType.x === 'pixels')
			img.style.marginLeft = (-options.anchorRef.x) + 'px';
		if (options.anchorType.y === 'pixels')
			img.style.marginTop  = (options.anchorRef.y - height + 1) + 'px';
	}
});


L.KMLMarker = L.Marker.extend({
	options: {
		icon: new L.KMLIcon.Default()
	}
});

// Inspired by https://github.com/bbecquet/Leaflet.PolylineDecorator/tree/master/src
L.RotatedImageOverlay = L.ImageOverlay.extend({
	options: {
		angle: 0
	},
	_reset: function () {
		L.ImageOverlay.prototype._reset.call(this);
		this._rotate();
	},
	_animateZoom: function (e) {
		L.ImageOverlay.prototype._animateZoom.call(this, e);
		this._rotate();
	},
	_rotate: function () {
        if (L.DomUtil.TRANSFORM) {
            // use the CSS transform rule if available
            this._image.style[L.DomUtil.TRANSFORM] += ' rotate(' + this.options.angle + 'deg)';
        } else if (L.Browser.ie) {
            // fallback for IE6, IE7, IE8
            var rad = this.options.angle * (Math.PI / 180),
                costheta = Math.cos(rad),
                sintheta = Math.sin(rad);
            this._image.style.filter += ' progid:DXImageTransform.Microsoft.Matrix(sizingMethod=\'auto expand\', M11=' +
                costheta + ', M12=' + (-sintheta) + ', M21=' + sintheta + ', M22=' + costheta + ')';
        }
	},
	getBounds: function () {
		return this._bounds;
	}
});

export function layer(options) {
	return new L.KML(options);
}

// Helper function for loading KMZ files
export function layerFromKMZ(kmzSource, options?) {
	const kmlLayer = new L.KML(null, options);
	kmlLayer.addKMZ(kmzSource, options);
	return kmlLayer;
}